// Lazy load function
const lazyLoad = (file) => () =>
    import(
      /* webpackChunkName: "[request]" */ `@/views/purchasing/${file}.vue`
    );

export default [
    {
        path: "/purchase-order",
        name: "purchase-order",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order-list'),
        },
    },

    {
        path: "/purchase-order/create*",
        name: "purchase-order-create",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order'),
        },
    },
    {
        path: "/purchase-order/edit/:id*",
        name: "purchase-order-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order'),
        },
    },
    {
        path: "/purchase-order/review/:id*",
        name: "purchase-order-review",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order'),
        },
    },
    // PO - V2
    {
        path: "/purchase-order-v2/create*",
        name: "purchase-order-v2-create",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order-v2'),
        },
    },
    {
        path: "/purchase-order-v2/edit/:id*",
        name: "purchase-order-v2-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order-v2'),
        },
    },
    {
        path: "/purchase-order-v2/review/:id*",
        name: "purchase-order-v2-review",
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order-v2'),
        },
    },

    {
        path: "/goods-in",
        name: "goods-in-list",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsIn" },
        components: {
            content: lazyLoad('goods-in-list'),
        },
    },
    {
        path: "/goods-in/review/:id*",
        name: "goods-in-review",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsIn" },
        components: {
            content: lazyLoad('goods-in'),
        },
    },
    {
        path: "/goods-in/edit/:id*",
        name: "goods-in-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsIn" },
        components: {
            content: lazyLoad('goods-in'),
        },
    },

    {
        path: "/goods-in-review",
        name: "goods-in-review-list",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsIn" },
        components: {
            content: lazyLoad('goods-in-review-list'),
        },
    },

    {
        path: "/supplier-invoice/review/:id",
        name: "supplier-invoice-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SupplierInvoice", // CreditCustomer
        },
        components: {
            content: lazyLoad('supplier-invoice'),
        },
    },
    {
        path: "/supplier-invoice/create*",
        name: "supplier-invoice-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SupplierInvoice", // CreditCustomer
        },
        components: {
            content: lazyLoad('supplier-invoice'),
        },
    },

    {
        path: "/goods-in-review/review/:id*",
        name: "goods-in-review-review",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsIn" },
        components: {
            content: lazyLoad('goods-in-review'),
        },
    },

    {
        path: "/supplier-invoiced",
        name: "supplier-invoiced",
        meta: { requiresAuth: true, applicationFeatureCode: "SupplierInvoice" },
        components: {
            content: lazyLoad('supplier-invoiced-list'),
        },
    },

    {
        path: "/purchase-planning/create",
        name: "purchase-planning-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "PurchasePlanning",
        },
        components: {
            content: lazyLoad('purchase-planning'),
        },
    },

    {
        path: "/purchase-planning-orders",
        name: "purchase-planning-orders",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "PurchasePlanning",
        },
        components: {
            content: lazyLoad('purchase-planning-orders-list'),
        },
    },


    {
        path: "/goods-return/review/:id*",
        name: "goods-return-review",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsReturn" },
        components: {
            content: lazyLoad('goods-return'),
        },
    },
    {
        path: "/goods-return/edit/:id*",
        name: "goods-return-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsReturn" },
        components: {
            content: lazyLoad('goods-return'),
        },
    },
    {
        path: "/supplier-credit/create/:id",
        name: "supplier-credit-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "SupplierInvoice",
        },
        components: {
            content: lazyLoad("supplier-credit"),
        },
    },
];
